import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';

// Icons
import { FaUsersCog, FaBoxOpen, FaBlog } from 'react-icons/fa';
import { RiTeamFill, RiServiceLine, RiArticleLine } from 'react-icons/ri';
import {
  MdOutlinePriceChange,
  MdOutlineQuestionAnswer,
  MdArrowBackIos,
  MdArrowForwardIos,
} from 'react-icons/md';
import { GiElbowPad } from 'react-icons/gi';

import './AdminNav.css';

const navItems = [
  { label: 'Users', path: '/admin/', icon: <FaUsersCog /> },
  { label: 'Team', path: '/admin/team-members', icon: <RiTeamFill /> },
  { label: 'Services', path: '/admin/services', icon: <RiServiceLine /> },
  { label: 'Prices', path: '/admin/prices', icon: <MdOutlinePriceChange /> },
  { label: 'Conditions', path: '/admin/conditions', icon: <GiElbowPad /> },
  { label: 'Products', path: '/admin/products', icon: <FaBoxOpen /> },
  { label: 'FAQs', path: '/admin/faq', icon: <MdOutlineQuestionAnswer /> },
  { divider: true },
  { label: `Blog\u00A0Posts`, path: '/admin/blog', icon: <RiArticleLine /> },
  { label: 'Blog Management', path: '/admin/blog-metadata', icon: <FaBlog /> },
];

const AdminNav = ({ isOpen, setIsOpen, toggle }) => {
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 500) {
        setIsOpen(false);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setIsOpen]);

  return (
    <aside
      id='admin-nav-container'
      className={!isOpen ? 'admin-nav-collapsed' : ''}
    >
      <div>
        {navItems.map((item, i) => (
          <div key={i}>
            {item.divider ? (
              <hr className='admin-nav-section-line' />
            ) : (
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  ['admin-nav-button', isActive ? 'admin-active-nav' : ''].join(
                    ' ',
                  )
                }
              >
                <span className='admin-nav-icon'>{item.icon}</span>
                <span className='admin-nav-text'>{item.label}</span>
              </NavLink>
            )}
          </div>
        ))}
        <hr className='admin-nav-section-line' />
        <button onClick={toggle} className='admin-nav-collapse-button'>
          {isOpen ? <MdArrowBackIos /> : <MdArrowForwardIos />}
        </button>
      </div>
    </aside>
  );
};

export default AdminNav;
